import styled from 'styled-components'

import { Padding, List } from '../../..'
import { colors } from '../../../../constants'
import { mediaQuery } from '../../../utils'

export const Frame = styled(Padding)`
    background: ${colors.greylighter};
    height: 100%;
    ${mediaQuery.mobile(`
    margin: 0px;
    padding: 0px;
  `)}
`

export const FrameContent = styled.div`
    background: ${colors.white};
    border: 1px solid ${colors.greylight};
    border-radius: 5px;
    box-shadow: 0 1px 4px 2px #c5d0dd63;
    height: 100%;
    overflow-y: auto;
`

export const BackLink = styled.a`
    color: grey;
    cursor: pointer;
    display: block;
    font-weight: normal;
    font-size: 15px;
    margin-bottom: 10px;
`

export const NullLinkWrapper = styled.div`
    display: inline-block;
`

export const StyledList = styled(List)`
    margin: 0;
    font-size: 14px;
`
